// https://devdactic.com/ionic-4-login-angular/
// https://github.com/danwilson/google-analytics-plugin#javascript-usage
// https://www.freakyjolly.com/ionic-4-adding-google-analytics-in-ionic-4-application-using-cordova-and-ionic-native-plugin/#more-1991

import { Injectable } from '@angular/core';
import { Platform, LoadingController, ToastController} from '@ionic/angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import {BehaviorSubject, interval} from 'rxjs';
import { StorageService } from '../storage/storage.service';
import { ApiService } from '../api/api.service';
import { GlobalVariables } from '../../common/global-variables';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  authenticationState = new BehaviorSubject(null);
  registrationState = new BehaviorSubject(null);
  loaderToShow: any;
  baseTime: any;
  authWatcher: any;

  constructor(private plt: Platform, private storageService: StorageService,
              private api: ApiService, public loadingController: LoadingController,
              public toastController: ToastController, private ga: GoogleAnalytics,
              public globals: GlobalVariables) {
    this.plt.ready().then(() => {
      this.checkToken();
    });
  }

  checkToken() {
    // check if device is registered
    this.storageService.getObject('device-info').then(info => {
      if (info) {
        this.globals.deviceInfo = info;
        this.authenticationState.next(false);
        this.registrationState.next(true);
        this.ga.setUserId(info.IMEI);
        this.ga.setAppVersion(info.appVersionCode);
      } else {
        // not registered
        this.authenticationState.next(null);
        this.registrationState.next(false);
      }
    });

    // check if logged in
    this.storageService.getObject('user-info').then(res => {
      if (res) {
        // console.log(res);
        // if logged in check TokenExpiration
        const tokenExpiration = res.tokenExpiresOn;
        const now = new Date();
        if (now < tokenExpiration) {
          this.globals.userInfo = res;
          this.authenticationState.next(true);
          this.registrationState.next(true);
          this.startSessionTimer(false);
          this.checkSessionTime();
        } else {
            this.authenticationState.next(false);
            this.registrationState.next(true);
        }
      }
    });
  }

  async login(payload) {
    this.showLoader('Authenticating Vendor..');
    const endpoint = this.globals.deviceInfo.remoteServer + 'login';
    this.api.postApiEndpoint(endpoint, payload).subscribe(resp => {
      // console.log(resp);
      if (resp.ok) {
        const userInfo = {
            username: resp.data.UserName,
            userID: resp.data.UserID,
            token: resp.data.token,
            internalVendor: resp.data.InternalVendor,
            EnableServices: resp.data.EnableServices,
            LangID: resp.data.LangID,
            CountryCode: resp.data.CountryCode,
            DefaultURL: resp.data.DefaultURL,
            OmniServiceURL: resp.data.OmniServiceURL,
            tokenExpiresOn: new Date().setDate( new Date().getDate() + 1 )
        };

        this.ga.setUserId(userInfo.username);

        this.globals.userInfo = userInfo;

        this.startSessionTimer(false);

        this.hideLoader();

        return this.storageService.setObject('user-info', userInfo).then(() => {
          this.authenticationState.next(true);
          // this.checkSessionTime();
        });
      } else {
        this.ga.trackException(resp.msg, true);
        this.hideLoader();
        this.presentToast(resp.msg, 'danger');
        return resp.msg;
      }
    }, error => {
      console.log(error);
      this.hideLoader();
      this.presentToast('Login failed ! \n Please check your server configurations or internet connection', 'danger');
      return error;
    });
  }

  logout() {
    return this.storageService.remove('user-info').then(() => {
      this.authenticationState.next(false);
      this.registrationState.next(true);
      this.authWatcher.unsubscribe();
    });
  }

  // Start or refresh a session timer
  startSessionTimer(refresh) {
      this.baseTime = new Date().getTime();
      // console.log(this.baseTime);
  }

  // Get the current session time
  async checkSessionTime() {
    let sessTime = 0;
    this.authWatcher = interval(1000).subscribe(pollCount => {
      try {
        const now = new Date().getTime();
        sessTime = now - this.baseTime;

        if (sessTime < 300000) {
          /// console.log(sessTime);
        } else {
          this.presentToast('Your Session has expired due to inactivity, please login again !', 'danger');
          this.logout();
        }
      } catch (e) {
        if (this.isAuthenticated()) {
            this.presentToast('Your Session has expired due to inactivity, please login again !', 'danger');
            this.logout();
          }
      }
    });
  }

  testServer() {
    this.presentToast('Testing server connection...', 'warning');
    const endpoint = this.globals.deviceInfo.remoteServer + 'test';
    console.log(this.globals.deviceInfo.remoteServer);
    this.api.getApiEndpoint(endpoint).subscribe(resp => {
      if (resp.ok) {
        this.presentToast(resp.msg, 'success');
      } else {
        this.presentToast(resp.msg, 'danger');
      }
    });
  }

  setupDevice(deviceInfo) {
    // console.log(deviceInfo);
    return this.storageService.setObject('device-info', deviceInfo).then(() => {

      // Save Configurations globally
      this.globals.deviceInfo = deviceInfo;

      this.authenticationState.next(false);
      this.registrationState.next(true);
      // this.hideLoader();
    });
  }

  resetDevice() {
    // remove any setup info on the device
    return this.storageService.clear().then(() => {
      this.authenticationState.next(null);
    });
  }

  isAuthenticated() {
    return this.authenticationState.value;
  }

  isRegistered() {
    return this.registrationState.value;
  }

  showLoader(displayMessage) {
    this.loaderToShow = this.loadingController.create({
      message: displayMessage
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        // console.log('Loading dismissed!');
      });
    });
    // this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
          this.loadingController.dismiss();
        }, 500);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      color
    });
    toast.present();
  }
}
